import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import moment from 'moment'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import {StateParamsModel} from 'src/app/modules/common/Model'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import {getTodayDate} from 'src/cms/helpers'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
// import * as branch from '../index'
import * as branch from '../index'
import AddBranch from './AddBranch'

const BranchComponent = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const {
    data,
    loading,
    importSuccess,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    exportSuccess,
    success,
    toggleLoading,
    deleteSuccess,
  } = useSelector((state: any) => state.branch)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()

  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableBranchData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(branch.actions.enableBranch(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableBranchData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(branch.actions.disableBranch(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let branchId = [rowData.id]
                setCheckedValues(branchId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.status}
            onClick={() => handleToggleAction(rowData)}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: {[key: string]: string}) => {
    data?.status
      ? dispatch(branch.actions.singleDisableBranch({id: data.id}))
      : dispatch(branch.actions.singleEnableBranch({id: data.id}))
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Name',
      dataKey: 'title',
      flexGrow: 1,
      cell: <Cell dataKey='title' />,
      sortable: true,
    },
    {
      label: 'Branch Manager',
      dataKey: 'branchManager',
      flexGrow: 1,
      cell: <Cell dataKey='branchManager' />,
      sortable: true,
    },
    {
      label: 'Address',
      dataKey: 'address',
      flexGrow: 1,
      cell: <Cell>{(rowData) => (rowData.address ? rowData.address : '-')}</Cell>,
      sortable: true,
    },
    {
      label: 'Telephone',
      dataKey: 'telephone',
      flexGrow: 1,
      cell: <Cell>{(rowData) => (rowData.telephone ? rowData.telephone : '-')}</Cell>,
      sortable: true,
    },
    {
      label: 'Email',
      dataKey: 'email',
      flexGrow: 1,
      cell: <Cell>{(rowData) => (rowData.email ? rowData.email : '-')}</Cell>,
      sortable: true,
    },

    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.status ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  useEffect(() => {
    dispatch(branch.actions.getBranchData(params))
  }, [params])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Branch deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Branch enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Branch disabled successfully')
    }
    if (importSuccess) {
      toast.success('Branch imported successfully')
    }
    if (deleteSuccess | enableSuccess | disableSuccess | importSuccess | exportSuccess) {
      handleChecked([])
      dispatch(branch.actions.getBranchData(params))
    }
  }, [deleteSuccess, success, enableSuccess, disableSuccess, importSuccess, exportSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Branch enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Branch disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const branchData = data?.branch
    ? data?.branch?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        address: item.address,
        address_np: item.address_np,
        branch_category: item.branch_category,
        cash_counter: item.cash_counter,
        category: item.category,
        closingTime: item?.closing_time
          ? moment(`${getTodayDate()} ${item?.closing_time}`).toDate()
          : null,
        code: item.code,
        description: item.description,
        description_np: item.description_np,
        district: item.district,
        email: item.email,
        extended_hour: item.extended_hour,
        fax: item.fax,
        id: item.id,
        branchManager: item?.branch_manager?.name,
        latitude: item.latitude,
        longitude: item.longitude,
        openingTime: item?.opening_time
          ? moment(`${getTodayDate()} ${item?.opening_time}`).toDate()
          : null,
        province: item.province,
        status: item.status,
        telephone: item.telephone,
        title: item.title,
        title_np: item.title_np,
        upcoming_branch: item.upcoming_branch,
        qos: item?.qos,
        iframe: item?.iframe,
        hide_in_website: item?.hide_in_website,
      }))
    : []

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  function fileImport(event: any) {
    if (!isEmpty(event.target.files)) {
      let formData = new FormData()
      formData.append('file', event.target.files[0])
      dispatch(branch?.actions?.importBranch(formData))
      event.target.value = null
    }
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let branchId = checkedValues?.map((value) => ({id: value}))
    dispatch(branch?.actions?.deleteBranch(branchId))
    handleAlertClose()
  }

  const handleExport = () => {
    dispatch(branch.actions.exportFile('Branch Data', params))
  }

  const handleTemplateExport = () => {
    dispatch(branch.actions.exportTemplateFile())
  }

  const handleRefresh = () => {
    dispatch(branch.actions.getBranchData(params))
  }

  return (
    <div className='shadow p-3 bg-white rounded'>
      <DesignComponent
        moduleName='Branch'
        params={params}
        setParams={setParams}
        handleRefresh={handleRefresh}
        handleAddModal={handleAddModal}
        handleAlertOpen={handleAlertOpen}
        handleExport={handleExport}
        handleImport={fileImport}
        enableMultiple={enableBranchData}
        disableMultiple={disableBranchData}
        templateButtonName='Download Template for Branch'
        templateLinkShow={true}
        handleTemplateExport={handleTemplateExport}
      />

      <div className='datatable'>
        <RSuiteTable
          onChecked={handleChecked}
          showCheckbox={true}
          columns={columns}
          data={branchData}
          checkedValues={checkedValues}
          showLoading={loading}
          handleSort={handleSort}
        />
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          className='mt-5'
          maxButtons={5}
          size='sm'
          layout={['total', '-', 'limit', '|', 'pager', 'skip']}
          total={data?.meta?.total || 0}
          limitOptions={[10, 20, 50, 100]}
          limit={params?.limit}
          activePage={params?.page}
          onChangePage={(value) => setParams({...params, page: value})}
          onChangeLimit={handleChangeLimit}
        />
        {open && (
          <AddBranch
            open={open}
            params={params}
            handleClose={handleClose}
            actionType={actionType}
            editSelectedData={editSelectedData}
          />
        )}
        {alertOpen && !isEmpty(checkedValues) && (
          <DeleteModal
            handleClick={() => handleDelete()}
            isOpen={alertOpen}
            handleClose={() => handleAlertClose()}
          />
        )}
      </div>
    </div>
  )
}

export default BranchComponent
